module.exports = __webpack_public_path__ + "img/votronic_12_40.44264d82.png";